import { Properties } from "../../../infrastructure/function-properties-types";

export default class Employee {
  static taxRegimes = ["general", "basque", "biscayan", "navarrese"];

  [key: string]: any;

  // from withFields
  id: string;

  internalId: string;

  costCenter: string;

  payrollCompany: string;

  name: string;

  firstSurname: string;

  secondSurname: string;

  surname: string;

  legalId: string;

  email: string;

  grossSalary: number | string | null;

  hiringDate: string;

  state: string;

  taxRegime: string;

  modelId: string;

  // from detail
  activationId: string;

  activeSinceTimestamp: Date;

  birthDate: string | Date;

  companyId: string;

  companyName: string;

  creationTimestamp: Date;

  constructor({
    id,
    internalId,
    costCenter,
    payrollCompany,
    name,
    firstSurname,
    secondSurname,
    surname,
    legalId,
    email,
    grossSalary,
    hiringDate,
    state,
    taxRegime,
    error,
    warning,
    activationId,
    activeSinceTimestamp,
    birthDate,
    companyId,
    companyName,
    creationTimestamp,
    modelId,
  }: Properties<Employee>) {
    const buildSurname = () => {
      if (firstSurname && firstSurname !== "") {
        if (secondSurname && secondSurname !== "") {
          return `${firstSurname} ${secondSurname}`;
        }
        return `${firstSurname}`;
      }
      return "";
    };

    this.id = id || "";
    this.internalId = internalId || "";
    this.costCenter = costCenter || "";
    this.payrollCompany = payrollCompany || "";
    this.name = name || "";
    this.firstSurname = firstSurname || "";
    this.secondSurname = secondSurname || "";
    this.surname = surname || buildSurname();
    this.legalId = legalId || "";
    this.email = email || "";
    this.grossSalary = parseInt(grossSalary, 10) || null;
    this.hiringDate = hiringDate || "";
    this.state = state || "";
    this.taxRegime = taxRegime || "";
    this.error = error || "";
    this.warning = warning || "";
    this.activationId = activationId || "";
    this.activeSinceTimestamp = activeSinceTimestamp || null;
    this.birthDate = birthDate || "";
    this.companyId = companyId || "";
    this.companyName = companyName || "";
    this.creationTimestamp = creationTimestamp || null;
    this.modelId = modelId || "";
  }

  withInternalId(internalId) {
    return new Employee({ ...this, internalId });
  }

  withName(name) {
    return new Employee({ ...this, name });
  }

  withFirstSurname(firstSurname) {
    return new Employee({ ...this, firstSurname });
  }

  withSecondSurname(secondSurname) {
    return new Employee({ ...this, secondSurname });
  }

  withLegalId(legalId) {
    return new Employee({ ...this, legalId });
  }

  withEmail(email) {
    return new Employee({ ...this, email });
  }

  withGrossSalary(grossSalary) {
    return new Employee({ ...this, grossSalary: +grossSalary });
  }
}

export type EmployeeConstructorArguments = Properties<Employee>;
